export const iconFontAwesomeLogisticsRoadCircleCheck = (
	<i className="fa-solid fa-road-circle-check"></i>
);
